import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/calculator.png'


const _withScopeId = n => (_pushScopeId("data-v-9120830c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-lg ecran-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Alerta aveti facturi depasite ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "click aici pentru vizualizare", -1))
const _hoisted_4 = {
  key: 1,
  class: "app__page__title__container"
}
const _hoisted_5 = { style: {"white-space":"nowrap","font-size":"2rem"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Pagina Principala")
const _hoisted_7 = { class: "dashboard__section" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashboard__div__title" }, "ACTIVITATE", -1))
const _hoisted_9 = { class: "dashboard__div__content" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" CAUTA ARTICOLE ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" ARTICOLE FAVORITE ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" OFERTE ")
const _hoisted_13 = { class: "dashboard__section" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashboard__div__title" }, "DATE FINANCIARE", -1))
const _hoisted_15 = { class: "dashboard__div__content" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" BALANTA ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" FACTURI ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" ALERTE ")
const _hoisted_19 = { class: "dashboard__section" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashboard__div__title" }, "CONTUL MEU", -1))
const _hoisted_21 = { class: "dashboard__div__content" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" DATE COMPANIE ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" UTILIZATORI ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" ADRESE DE LIVRARE ")
const _hoisted_25 = { class: "dashboard__section" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashboard__div__title" }, "INFO UTILE", -1))
const _hoisted_27 = { class: "dashboard__div__content" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" SERVICE CENTER ")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" CALCULATOR GREUTATE SPECIFICA ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showAlertDepasireTermenFacturi)
      ? (_openBlock(), _createBlock(_component_q_banner, {
          key: 0,
          dense: "",
          "inline-actions": "",
          class: "text-white bg-red q-ma-md",
          style: {"width":"100%","margin":"0 auto","cursor":"pointer"},
          onClick: _ctx.onGoFacturi
        }, {
          action: _withCtx(() => [
            _createVNode(_component_q_icon, {
              color: "white",
              name: "close",
              onClick: _ctx.closeAlertDepasireTermenFacturi,
              style: {"cursor":"pointer"}
            }, null, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.$q.platform.is.desktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_q_icon, {
              name: "dashboard",
              style: {"font-size":"2rem","position":"relative","top":"-3px"},
              color: "primary"
            }),
            _hoisted_6
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onGoCautaArticole && _ctx.onGoCautaArticole(...args)))
        }, [
          _createVNode(_component_q_icon, {
            name: "category",
            color: "primary",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }),
          _hoisted_10
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onGoArticoleFavorite && _ctx.onGoArticoleFavorite(...args)))
        }, [
          _createVNode(_component_q_icon, {
            name: "favorite_border",
            color: "primary",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }),
          _hoisted_11
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onGoToOffers && _ctx.onGoToOffers(...args)))
        }, [
          _createVNode(_component_q_icon, {
            name: "shop",
            color: "primary",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }),
          _hoisted_12,
          (_ctx.userStore.countOferte>0)
            ? (_openBlock(), _createBlock(_component_q_badge, {
                key: 0,
                color: "red",
                class: "badge__superscript--top",
                style: {"height":"1rem","margin-left":"8px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.userStore.countOferte), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 512), [
          [_directive_ripple]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onGoBalanta && _ctx.onGoBalanta(...args)))
        }, [
          _createVNode(_component_q_icon, {
            name: "star_rate",
            color: "primary",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }),
          _hoisted_16
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onGoFacturi && _ctx.onGoFacturi(...args)))
        }, [
          _createVNode(_component_q_icon, {
            name: "paid",
            color: "primary",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }),
          _hoisted_17
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onGoAlerte && _ctx.onGoAlerte(...args)))
        }, [
          _createVNode(_component_q_icon, {
            name: "notifications_active",
            color: "primary",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }),
          _hoisted_18,
          (_ctx.showAlertCount)
            ? (_openBlock(), _createBlock(_component_q_badge, {
                key: 0,
                color: "red",
                transparent: "",
                class: "badge__superscript--top",
                style: {"height":"1rem","margin-left":"8px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.overdueInvoiceCount), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 512), [
          [_directive_ripple]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createElementVNode("div", _hoisted_21, [
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onGoDateCompanie && _ctx.onGoDateCompanie(...args)))
        }, [
          _createVNode(_component_q_icon, {
            name: "account_balance",
            color: "primary",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }),
          _hoisted_22
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onGoUsersCompany && _ctx.onGoUsersCompany(...args)))
        }, [
          _createVNode(_component_q_icon, {
            name: "people",
            color: "primary",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }),
          _hoisted_23
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onGoNomAdreseLivrare && _ctx.onGoNomAdreseLivrare(...args)))
        }, [
          _createVNode(_component_q_icon, {
            name: "local_shipping",
            color: "primary",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }),
          _hoisted_24,
          (_ctx.userStore.countAdrese>0)
            ? (_openBlock(), _createBlock(_component_q_badge, {
                key: 0,
                color: "red",
                class: "badge__superscript--top",
                style: {"height":"1rem","margin-left":"8px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.userStore.countAdrese), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 512), [
          [_directive_ripple]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _hoisted_26,
      _createElementVNode("div", _hoisted_27, [
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openLink('https://melindasteel.ro/contact')))
        }, [
          _createVNode(_component_q_icon, {
            name: "call",
            color: "primary",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }),
          _hoisted_28
        ], 512), [
          [_directive_ripple]
        ]),
        _withDirectives(_createElementVNode("div", {
          class: "dashboard__div__parameter",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.openLink('https://melindasteel.ro/calculator-greutate-specifica')))
        }, [
          _createVNode(_component_q_icon, {
            color: "primary",
            style: {"font-size":"1.4rem","padding-right":"0.3rem"}
          }, {
            default: _withCtx(() => [
              _hoisted_29
            ]),
            _: 1
          }),
          _hoisted_30
        ], 512), [
          [_directive_ripple]
        ])
      ])
    ])
  ]))
}